import {getBrand} from '../../helpers';

export const selectPlayerVolume = state => {
    return state.player.volume;
};

export const selectVideoQuality = state => {
    return state.player.videoQuality;
};

export const selectPlayerAudio = state => {
    return state.player.audio;
};

export const selectAdUnit = state => {
    let brand = getBrand();
    let config = state.config;
    let user = state.user;
    var adTagUrl = null;

    if (brand === 'cnapp') {
        if (
            config.player_settings &&
            config.player_settings.ads &&
            config.player_settings.ads.enabled
        ) {
            adTagUrl = config.player_settings.ads.tveAd;
        }

        if (adTagUrl && adTagUrl.indexOf('[countryname]')) {
            if (user.countryIsoCode) {
                adTagUrl = adTagUrl.replace(
                    '[countryname]',
                    ['ar', 'br', 'co', 'cl', 'mx', 've'].includes(
                        user.countryIsoCode.toLowerCase(),
                    )
                        ? user.countryIsoCode.toLowerCase()
                        : 'la',
                );
            } else {
                adTagUrl = undefined;
            }
        }
        return adTagUrl;
    } else if (brand === 'cnito') {
        // eslint-disable-next-line max-len
        return 'https://pubads.g.doubleclick.net/gampad/ads?sz=970x250%7C320x50%7C300x250%7C728x90%7C640x480&iu=/99911224/ci_la&env=vp&impl=s&gdfp_req=1&output=vast&unviewed_position_start=1&description_url=http%3A%2F%2Fwww.cartoonitola.com&correlator=';
    }
    return null;
};
